// Set to true to hide the section, false to show it.

export const isSocialDisable = true;
export const isContactUsDisable = true;
export const isReferencesPageDisable = true;
